/**
 * @generated SignedSource<<04a29015e62a23d4d3196802d0a1989b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleSearchResultListArticleSearchEdge$data = ReadonlyArray<{
  readonly node: {
    readonly content: {
      readonly " $fragmentSpreads": FragmentRefs<"searchContentItemContent">;
    } | null | undefined;
    readonly id: string;
  };
  readonly " $fragmentType": "articleSearchResultListArticleSearchEdge";
}>;
export type articleSearchResultListArticleSearchEdge$key = ReadonlyArray<{
  readonly " $data"?: articleSearchResultListArticleSearchEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleSearchResultListArticleSearchEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "articleSearchResultListArticleSearchEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleSearchResultItem",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "searchContentItemContent"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ArticleSearchEdge",
  "abstractKey": null
};

(node as any).hash = "3f453441e4567a50875418d19c9514fd";

export default node;
